/**
 * Social Engagement — Learn-Mode inline tips.
 *
 * Anchored across `routes/social/Engagement.tsx` and
 * `components/engagement/AddTargetsDialog.tsx`.
 */

import type { LearnTip } from "./types";

export const engagementTips: LearnTip[] = [
  {
    key: "social-engagement",
    title: "Engagement",
    body: "The daily outbound engagement block — a human one-taps through suggested partners, mentions, UGC tags, competitors and local accounts to engage with. Nothing posts on its own; you open the post, paste the suggested comment, then mark it done.",
  },
  {
    key: "social-engagement-today",
    title: "Today's Block",
    body: "A balanced mix of suggestions for this client, capped at their daily target and spread across mentions, partners, members and competitors so no single kind crowds out the rest.",
    bullets: [
      "Open takes you straight to the post or profile in a new tab.",
      "Copy grabs the suggested comment so you can paste it in — edit it first if it doesn't quite fit.",
      "Done and Skip both free up a slot; Refresh pulls in new targets once you've worked through the block.",
    ],
  },
  {
    key: "social-engagement-history",
    title: "History",
    body: "Every target this client has ever been suggested, whatever happened to it — done, skipped, or expired without action. Filter by status to review what your team has been working on.",
  },
  {
    key: "social-engagement-add-targets",
    title: "Add Targets",
    body: "Hand-add accounts to the queue — a Chamber member list, a list of local partners, anyone you want suggested in the daily block. Add one row per handle; handles already in the queue for this client are skipped automatically.",
  },
];
